module.exports = __webpack_public_path__ + "static/media/remove.cc7f6744.svg";